import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function SdsIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="SDSIcon_svg__Layer_1"
        viewBox="0 0 68 68"
        {...props}
      >
        <defs>
          <style>
            {
              '.SDSIcon_svg__cls-1,.SDSIcon_svg__cls-2{fill:none}.SDSIcon_svg__cls-2,.SDSIcon_svg__cls-6{stroke-linecap:round;stroke:currentColor;stroke-width:2px}'
            }
          </style>
        </defs>
        <g id="SDSIcon_svg__Group_4146">
          <g id="SDSIcon_svg__Ellipse_27">
            <circle cx={34} cy={34} r={34} className="SDSIcon_svg__cls-1" />
            <circle
              cx={34}
              cy={34}
              r={33}
              style={{
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: 2,
              }}
            />
          </g>
          <g id="SDSIcon_svg__Group_4145">
            <g id="SDSIcon_svg__Group_4143">
              <g id="SDSIcon_svg__Group_4136">
                <g id="SDSIcon_svg__Group_4133">
                  <path
                    id="SDSIcon_svg__Path_1919"
                    d="M25.77 51.41v1.67s-.11.85.45.93 6.66 0 6.66 0h16.98s1.1.1 1.13-.88 0-34.08 0-34.08-.16-.88-.74-.88h-9.23"
                    className="SDSIcon_svg__cls-2"
                  />
                </g>
              </g>
              <g id="SDSIcon_svg__Group_4140">
                <g id="SDSIcon_svg__Group_3983">
                  <path
                    id="SDSIcon_svg__Path_1880"
                    d="M50.33 39.25h-4.22"
                    className="SDSIcon_svg__cls-2"
                  />
                  <path
                    id="SDSIcon_svg__Path_1994"
                    d="M50.33 33.67h-4.22"
                    className="SDSIcon_svg__cls-2"
                  />
                  <path
                    id="SDSIcon_svg__Path_1996"
                    d="M50.33 28.09h-4.22"
                    className="SDSIcon_svg__cls-2"
                  />
                  <path
                    id="SDSIcon_svg__Path_1881"
                    d="M49.14 44.83h-3.03"
                    className="SDSIcon_svg__cls-6"
                  />
                </g>
              </g>
            </g>
            <g id="SDSIcon_svg__Group_4245">
              <g id="SDSIcon_svg__Group_4133-2">
                <g id="SDSIcon_svg__Path_2085">
                  <path
                    d="M17 14s16.97.04 18.97 0 1.83-.02 2.18.16c.36.18 7.43 6.47 7.43 6.47.41.33.43.9.42 1.7s0 27.66 0 27.66c0 1.1-.9 2-2 2H17c-1.1 0-2-.9-2-2V16c0-1.1.9-2 2-2"
                    className="SDSIcon_svg__cls-1"
                  />
                  <path
                    d="M37.15 15.99c-.26 0-.63 0-1.14.01-.6.01-2.57.02-5.84.02-5.56 0-13.09-.02-13.16-.02v34h27V21.9c-2.44-2.17-5.79-5.12-6.75-5.92h-.1m0-2c.77 0 .74.04 1 .18.36.18 7.43 6.47 7.43 6.47.41.33.43.9.42 1.7v27.66c0 1.1-.9 2-2 2H17c-1.1 0-2-.9-2-2V16c0-1.1.9-2 2-2 0 0 16.97.04 18.97 0 .53 0 .9-.01 1.18-.01Z"
                    className="SDSIcon_svg__cls-5"
                  />
                </g>
              </g>
            </g>
            <g id="SDSIcon_svg__Group_4144">
              <g id="SDSIcon_svg__Group_4142">
                <g id="SDSIcon_svg__Group_4136-2">
                  <g id="SDSIcon_svg__Group_4133-3">
                    <path
                      id="SDSIcon_svg__Path_1883"
                      d="M37.69 15.13c.33.21 5.1 4.45 5.69 4.89.57.48 1.12.99 1.63 1.54l-7.88-.17c-.86-.03-1.14-.21-1.16-1.04v-5.34c.58-.06 1.16-.02 1.73.12Z"
                      style={{
                        fill: 'none',
                        stroke: 'currentColor',
                        strokeWidth: 2,
                        strokeLinejoin: 'round',
                      }}
                    />
                  </g>
                </g>
                <g id="SDSIcon_svg__Group_4140-2">
                  <g id="SDSIcon_svg__Group_3983-2">
                    <path
                      id="SDSIcon_svg__Path_1880-2"
                      d="M38.73 34.79h-17.8"
                      className="SDSIcon_svg__cls-2"
                    />
                    <path
                      id="SDSIcon_svg__Path_1995"
                      d="M38.73 25.79h-17.8"
                      className="SDSIcon_svg__cls-2"
                    />
                    <path
                      id="SDSIcon_svg__Path_1882"
                      d="M29.61 42.79h-8.69"
                      className="SDSIcon_svg__cls-6"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Icon>
  )
}
export default SdsIcon
